import { render, staticRenderFns } from "./CallCard.vue?vue&type=template&id=c2e2a342&scoped=true&"
import script from "./CallCard.vue?vue&type=script&lang=ts&"
export * from "./CallCard.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=c2e2a342&prod&scoped=true&lang=css&"
import style1 from "./CallCard.vue?vue&type=style&index=1&id=c2e2a342&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e2a342",
  null
  
)

export default component.exports